import React, { useState, useEffect } from 'react';
import { Search, Clock, Calendar, MapPin, Info, FileText } from 'lucide-react';

// Data programu konference
const programData = [
  // 8:00
  { time: '8:00', title: 'Začátek registrací', speaker: '', room: 'Hlavní sál', description: 'I pokud jste se neregistrovali přes web, můžete bez obav přijít a registrovat se na místě.', pdfFilename: '' },
  
  // 8:30
  { time: '8:30', title: 'Úvod z pódia', speaker: '', room: 'Hlavní sál', description: 'Zahájení konference s Mikolášem Tučkem, Patrickem Zandlem, Lindou Kašpárkovou a dalšími lidmi konferenčního týmu. Zatím se nic důležitého neděje, jen vás informujeme o tom, jak bude den probíhat...', pdfFilename: '' },
  
  // 9:00
  { time: '9:00', title: 'Úvodní poselství předsedy Pirátů', speaker: 'Zdeněk Hřib', room: 'Hlavní sál', description: 'Předseda pirátů shrne to, jak se piráti připravují na zteč.', pdfFilename: '' },
  
  // 9:30
  { time: '9:30', title: 'Co jsme dokázali?', speaker: 'Ivan Bartoš', room: 'Hlavní sál', description: 'Co se Pirátům podařilo a na co může být pyšní? A především, dalších 20 minut na vaše dotazy! ', pdfFilename: 'Vysledky_Piratu_2021_2025_Kompas_2025.pdf' },
  
  // 10:00
  { time: '10:00', title: 'Férová tržní ekonomika', speaker: 'Libor Dušek', room: 'Hlavní sál', description: 'Jak by měla vypadat ekonomická politika, která nebude ztrácet cíle a bude věnovat se lidem? Tak především bude férová, transparentní a tržní. Jenže, co to znamená?', pdfFilename: 'libor-dusek-ferova-ekonomika.pdf' },

  
  // 10:30
  { time: '10:30', title: 'Poselství naděje z vězeňského autobusu', speaker: 'Jakub Horák', room: 'Hlavní sál', description: 'Trocha ostrých slov na rozproudění krve od člověka, který se v politickém marketingu pohybuje lét a stál i u úspěšné kampaně do sněmovny v roce 2017.', pdfFilename: '' },
  
  // 11:00
  { time: '11:00', title: 'Evropský strategický rámec z pohledu Česka: vize, výhled a příležitosti', speaker: 'Václav Vislous', room: 'Hlavní sál', description: 'Jak chce vedení Evropské unie čelit aktuálním výzvám v oblastech konkurenceschopnosti? Přehled plánovaných opatření a jejich dopad na Česko. Strategický finanční výhled pro střednědobé období. Přehled klíčových strategických výzev Česka a jak je využít.', pdfFilename: 'Kompas-2025-Vislous.pdf' },
  
  // 11:30
  { time: '11:30', title: 'Kampaňová debata', speaker: 'Zdeněk Hřib, Ivan Bartoš, Libor Dušek', room: 'Hlavní sál', description: 'A tohle je ta správná chvíle zeptat se našich lídrů a ekonomů na to, co vás zajímá, aby se ještě stihly zapracovat poznatky do kampaně. ', pdfFilename: '' },
  
  // 12:00
  { time: '12:00', title: 'oběd', speaker: '', room: 'Tácy na Pankráci', description: 'Máme restauraci Tácy na Pankráci, kde se můžete rychle a dobře najíst, stačí jen projít dveřmi v konferenčním centru. Polévka 0,2 l / Hlavní jídlo ( hotové jídlo nebo bezmasé jídlo ) / Nealkoholický nápoj 0,2 l za 200 Kč plus DPH (kdo víte, kolik je DPH za jídlo? Poslouchali jste na přednášce?', pdfFilename: '' },
  
  // 13:00
  { time: '13:00', title: 'Jak na veřejné rozpočty, aby byly cílené, efektivní a vyhodnocované', speaker: 'Aleš Bělohradský, Patrick Zandl, Jiří Knotek', room: 'Ekonomika', description: 'Veřejné rozpočty jsou jedním z hlavních nástrojů pro naplňování cílů veřejných politik. Přesto je jejich vazba na cíle obvykle slabá až žádná. Budeme diskutovat o tom, jestli rozpočty musí vypadat tako jako vždycky, nebo je možné je nastavit cíleněji a proč by to bylo dobré.', pdfFilename: '' },
  { time: '13:00', title: 'Strategie Bydlení: byty a bity', speaker: 'Ivan Bartoš', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: 'Strategie_Bydleni_Byty_a_bity_Kompas_2025.pdf' },
  { time: '13:00', title: 'Děti, práce a ekonomický růst?', speaker: 'Olga Richterová, Martina Dvořáková (FérováDomácnost.cz) a zástupkyně Mumdoo, Lucie Bášová', room: 'Vzdělání & Společnost', description: '', pdfFilename: 'olga-richterova-2.pdf' },

  // 13:30
  { time: '13:30', title: 'Kreativní odvětví jako moderní motor ekonomiky', speaker: 'Ondřej Chrást', room: 'Ekonomika', description: 'Význam kreativních odvětví pro ekonomický růst a celkový rozvoj společnosti ve světě i v České republice se každoročně zvětšuje,podpora kreativity je jasnou podporou zdroje inovací a ekonomického růstu. Kreativní odvětví, zahrnující např. design, filmový a herní průmysl, architekturu či nově i využití AI, výrazně přispívají k HDP, zaměstnávají mladé talenty a podporují export. V příspěvku ukazujeme příležitosti i výzvy, včetně potřeby systematické podpory, regionální vyváženosti a ochrany kulturní identity.', pdfFilename: 'Chrast_Kompas_Kreativni-odvetvi-jako-motor-ekonomickeho-rustu.pdf'  },
  { time: '13:30', title: 'Urbanismus', speaker: 'Peter Bednar (Cigler arch.)', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: 'peter-bednar_compressed.pdf' },
  { time: '13:30', title: 'Děti, práce a ekonomický růst?', speaker: 'Olga Richterová, Martina Dvořáková (FérováDomácnost.cz) a zástupkyně Mumdoo, Lucie Bášová', room: 'Vzdělání & Společnost', description: '', pdfFilename: 'martina-dvorakova.pdf' },
  
  // 14:00
  { time: '14:00', title: 'Vzhůr Česko, panelová diskuse', speaker: 'Václav Vislous, Jiří Hlavenka, Michal Bláha, Veronika Nurnbergerová', room: 'Ekonomika', description: '', pdfFilename: '' },
  { time: '14:00', title: 'Jak postavit novou čtvrť v Praze', speaker: 'Jakub Michálek', room: 'Bydlení & Životní prostředí', description: 'Vize nového města pro 200 tisíc obyvatel s technologickým centrem a dostupným bydlením v okolí Prahy. Řešení nedostupnosti bydlení a kapacitního růstu města inspirované historickými etapami rozvoje a evropskými technologickými čtvrtěmi. Návrh financování kombinující soukromý a veřejný sektor. Koncepce správy a rozvoje včetně redukce městských částí a rozšíření Prahy o blízká města a obce.', pdfFilename: 'jakub-michalek-bydleni.pdf' },
  { time: '14:00', title: 'Rovné příležitosti, rovní Piráti', speaker: 'Adam Šenk, Vendula Kučerová', room: 'Vzdělání & Společnost', description: '', pdfFilename: '' },
  
  // 14:30
  { time: '14:30', title: 'Velká politika v malém kraji', speaker: 'Jiří Hlavenka', room: 'Ekonomika', description: 'Dá se z úrovně kraje dělat velká politika?', pdfFilename: 'Hlavenka_Kompas 2025.pdf' },
  { time: '14:30', title: 'Panelová diskuse o developmentu bydlení', speaker: 'Peter Bednar, Jakub Michálek, Elen Kovalčíková, Jana Kabelová', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: '' },
  { time: '14:30', title: 'Rovné odměňování a důsledky pro ekonomiku, rodiny, partnerské vztahy', speaker: 'Petra Haken', room: 'Vzdělání & Společnost', description: 'Analýza příčin nerovného odměňování v České republice a jeho dopadů na ekonomický i společenský rozvoj. Přehled mýtů spojených s rozdíly v odměňování a inspirace příklady ze zahraničí, zejména ze Švédska. Návrhy konkrétních kroků ke zvýšení transparentnosti, podpoře slaďování práce a péče a zlepšení ohodnocení "měkkých" profesí. Reflexe médií a veřejné debaty o férovém odměňování v českém kontextu.', pdfFilename: 'hanek-ferove-odmenovani.pdf' },
  
  // 15:00
  { time: '15:00', title: 'Ekonomika, trh práce, socialni dávky a důchody', speaker: 'Filip Pertold', room: 'Ekonomika', description: '', pdfFilename: 'Pertold_reformy_pirati1.pdf' },
  { time: '15:00', title: 'Green Deal', speaker: 'Lukáš Blažej a Petr Daniš', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: '' },
  { time: '15:00', title: 'Jak je zdravotnictví připraveno na další krizi', speaker: 'Jana Šeblová', room: 'Vzdělání & Společnost', description: '', pdfFilename: 'seblova-krizova-pripravenost-zdravotnictvi.pdf' },
  
  // 15:30
  { time: '15:30', title: 'Covfefe brejk', speaker: '', room: 'Ekonomika', description: 'Přestávka na kávu', pdfFilename: '' },
  { time: '15:30', title: 'Covfefe brejk', speaker: '', room: 'Bydlení & Životní prostředí', description: 'Přestávka na kávu', pdfFilename: '' },
  { time: '15:30', title: 'Covfefe brejk', speaker: '', room: 'Vzdělání & Společnost', description: 'Přestávka na kávu', pdfFilename: '' },
  
  // 16:00
  { time: '16:00', title: 'Evropa a Obrana', speaker: 'Jan Hora', room: 'Ekonomika', description: '', pdfFilename: 'Hora_Obrana-KOMPAS.pdf' },
  { time: '16:00', title: 'Co je třeba opravit na Green Dealu? Vodík!', speaker: 'Tereza Nislerová', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: 'tereza-nislerova.pdf' },
  { time: '16:00', title: 'Zdravé cigarety pro naše děti', speaker: 'Michal Škerle', room: 'Vzdělání & Společnost', description: '', pdfFilename: 'skerle-zdrave-cigarety.pdf' },

  
  // 16:30
  { time: '16:30', title: 'Diskusní panel Evropa a Obrana', speaker: 'Jan Hora, Václav Vislouš, Jakub Wolf, Tereza Nislerová', room: 'Ekonomika', description: '', pdfFilename: '' },
  { time: '16:30', title: 'Zemědělské dotace a strategická bezpečnost', speaker: 'Milan Daďourek', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: 'dadourek.pdf' },
  { time: '16:30', title: 'Progresivní alternativa', speaker: 'Lukáš Kohout', room: 'Vzdělání & Společnost', description: 'Co je Progresivní alternativa v Pirátské straně a koho chce oslovat?', pdfFilename: '' },
  
  // 17:00
  { time: '17:00', title: 'Digitalizace a efektivita', speaker: 'Michal Bláha, Jan Klofáč', room: 'Ekonomika', description: '', pdfFilename: '' },
  { time: '17:00', title: 'Lesy ve službě společnosti', speaker: 'Jiří Lehejček', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: '' },
  { time: '17:00', title: 'Dopravní Pecha Kucha podvečer s diskusí', speaker: '', room: 'Vzdělání & Společnost', description: '', pdfFilename: '' },
  
  // 17:30
  { time: '17:30', title: 'Problémy školství a jeho role v moderním Česku', speaker: 'Veronika Nürnbergerová', room: 'Ekonomika', description: 'o problematice školství, jehož přítomnost definguje naši budoucnost', pdfFilename: 'NÜRNBERGEROVÁ_Kompas 2025.pdf' },
  { time: '17:30', title: 'Duševní zdraví a vzdělávání', speaker: 'Petr Chaluš', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: '' },
  { time: '17:30', title: 'Dopravní Pecha Kucha podvečer s diskusí', speaker: 'Gabriela Lněničková, Marek Lahoda, Petr Zámečník et al', room: 'Vzdělání & Společnost', description: 'Pokračování Pecha Kucha', pdfFilename: '' },
  
  // 18:00
  { time: '18:00', title: 'zakončení programu', speaker: '', room: 'Ekonomika', description: '', pdfFilename: '' },
  { time: '18:00', title: 'zakončení programu', speaker: '', room: 'Bydlení & Životní prostředí', description: '', pdfFilename: '' },
  { time: '18:00', title: 'zakončení programu', speaker: '', room: 'Vzdělání & Společnost', description: '', pdfFilename: '' },
];

// Barevné schéma pro sály
const roomColors = {
  'Ekonomika': {
    bg: 'bg-gray-100',
    border: 'border-gray-400',
    text: 'text-gray-800',
    light: 'bg-gray-50'
  },
  'Bydlení & Životní prostředí': {
    bg: 'bg-green-100',
    border: 'border-green-400',
    text: 'text-green-800',
    light: 'bg-green-50'
  },
  'Vzdělání & Společnost': {
    bg: 'bg-yellow-100',
    border: 'border-yellow-400',
    text: 'text-yellow-800',
    light: 'bg-yellow-50'
  },
  'všechny sály': {
    bg: 'bg-blue-100',
    border: 'border-blue-400',
    text: 'text-blue-800',
    light: 'bg-blue-50'
  }
};

// Hlavní komponenta
const KompasApp = () => {
  const [time, setTime] = useState(new Date());
  const [view, setView] = useState('current'); // 'current', 'timeline', 'rooms', 'search', 'presentations'
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [activeRoom, setActiveRoom] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSimulatedTime, setIsSimulatedTime] = useState(false);

  // Funkce pro nastavení cookie
  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  };

  // Funkce pro získání hodnoty cookie
  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  // Funkce pro simulaci času
  const simulateTime = () => {
    const simulatedDate = new Date('2025-04-26T18:00:00');
    setTime(simulatedDate);
    setIsSimulatedTime(true);
    setCookie('simulatedTime', 'true', 1);
    // Přidáme parametr do URL bez obnovení stránky
    const url = new URL(window.location.href);
    url.searchParams.set('simulate', 'true');
    window.history.pushState({}, '', url);
  };

  // Funkce pro návrat k reálnému času
  const resetToRealTime = () => {
    setTime(new Date());
    setIsSimulatedTime(false);
    setCookie('simulatedTime', 'false', 1);
    // Odstraníme parametr z URL bez obnovení stránky
    const url = new URL(window.location.href);
    url.searchParams.delete('simulate');
    window.history.pushState({}, '', url);
  };

  // Kontrola URL parametru pro simulaci času
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const simulateTime = urlParams.get('simulate_time');
    
    if (simulateTime === 'end') {
      const simulatedDate = new Date('2025-04-26T18:00:00');
      setTime(simulatedDate);
    }
  }, []);

  // Aktualizace času každou minutu
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 60000);
    
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Formátování času pro porovnání
  const formatTimeForComparison = (timeString) => {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Získání aktuálně probíhajících přednášek
  const getCurrentSessions = () => {
    const currentHour = time.getHours();
    const currentMinute = time.getMinutes();
    const currentTimeValue = currentHour * 60 + currentMinute;
    const currentDate = time.getDate();
    const currentMonth = time.getMonth() + 1; // getMonth() je 0-indexovaný
    const currentYear = time.getFullYear();
    
    // Konference probíhá 25.4.-26.4.2025
    const conferenceStartDate = new Date(2025, 3, 25); // Měsíce jsou 0-indexované
    const conferenceEndDate = new Date(2025, 3, 26, 23, 59, 59);
    const currentFullDate = new Date(currentYear, currentMonth - 1, currentDate);
    
    // Kontrola, zda jsme v datech konference
    const isBeforeConference = currentFullDate < conferenceStartDate;
    const isAfterConference = currentFullDate > conferenceEndDate;
    const isDuringConference = !isBeforeConference && !isAfterConference;
    
    // Pokud jsme mimo datum konference, vraťte prázdné pole
    if (!isDuringConference) {
      return { sessions: [], conferenceStatus: isBeforeConference ? 'before' : 'after' };
    }
    
    // Najdeme všechny časové sloty
    const allTimes = [...new Set(programData.map(item => item.time))].sort((a, b) => 
      formatTimeForComparison(a) - formatTimeForComparison(b)
    );
    
    // Najdeme nejbližší předchozí časový slot
    let currentTimeSlot = allTimes[0];
    let isActiveTimeSlot = false;
    
    for (let i = 0; i < allTimes.length; i++) {
      const slotTime = formatTimeForComparison(allTimes[i]);
      if (slotTime <= currentTimeValue && (i === allTimes.length - 1 || formatTimeForComparison(allTimes[i+1]) > currentTimeValue)) {
        currentTimeSlot = allTimes[i];
        isActiveTimeSlot = true;
        break;
      }
    }
    
    return { 
      sessions: programData.filter(item => item.time === currentTimeSlot),
      conferenceStatus: isDuringConference ? (isActiveTimeSlot ? 'active' : 'inactive') : (isBeforeConference ? 'before' : 'after')
    };
  };

  // Získání následujících přednášek
  const getNextSessions = () => {
    const currentTimeValue = time.getHours() * 60 + time.getMinutes();
    const allTimes = [...new Set(programData.map(item => item.time))].sort((a, b) => 
      formatTimeForComparison(a) - formatTimeForComparison(b)
    );
    
    // Najdeme nejbližší následující časový slot
    let nextTimeSlot = null;
    for (let i = 0; i < allTimes.length; i++) {
      const slotTime = formatTimeForComparison(allTimes[i]);
      if (slotTime > currentTimeValue) {
        nextTimeSlot = allTimes[i];
        break;
      }
    }
    
    if (!nextTimeSlot) return [];
    
    return programData.filter(item => item.time === nextTimeSlot);
  };

  // Vyhledávání
  const handleSearch = (term) => {
    setSearchTerm(term);
    
    if (!term.trim()) {
      setSearchResults([]);
      return;
    }
    
    const results = programData.filter(
      item => 
        item.title.toLowerCase().includes(term.toLowerCase()) ||
        item.speaker.toLowerCase().includes(term.toLowerCase()) ||
        item.description.toLowerCase().includes(term.toLowerCase()) ||
        item.room.toLowerCase().includes(term.toLowerCase())
    );
    
    setSearchResults(results);
    if (results.length > 0 && view !== 'search') {
      setView('search');
    }
  };

  // Získání jedinečných časových slotů
  const getTimeSlots = () => {
    return [...new Set(programData.map(item => item.time))].sort((a, b) => 
      formatTimeForComparison(a) - formatTimeForComparison(b)
    );
  };

  // Získání jedinečných místností
  const getRooms = () => {
    const mainRooms = ['Ekonomika', 'Bydlení & Životní prostředí', 'Vzdělání & Společnost'];
    return [...new Set(programData.map(item => item.room))]
      .filter(room => mainRooms.includes(room));
  };

  // Získání přednášek pro daný časový slot
  const getSessionsByTime = (timeSlot) => {
    return programData.filter(item => item.time === timeSlot);
  };

  // Získání přednášek pro danou místnost
  const getSessionsByRoom = (room) => {
    return programData.filter(item => item.room === room || item.room === 'Hlavní sál')
      .sort((a, b) => formatTimeForComparison(a.time) - formatTimeForComparison(b.time));
  };

  // Kompaktní zobrazení přednášky pro paralelní zobrazení
  const CompactSessionCard = ({ session }) => {
    const colors = roomColors[session.room];
    return (
      <div className={`h-full p-3 rounded-lg ${colors.light} border-l-4 ${colors.border} flex flex-col`}>
        <div className="font-bold">{session.title}</div>
        {session.speaker && <div className="text-sm mt-1 text-gray-600">{session.speaker}</div>}
        <div className={`text-sm mt-auto pt-2 ${colors.text} font-medium`}>{session.room}</div>
      </div>
    );
  };

  const isSessionOlderThan20Minutes = (sessionTime) => {
    const [hours, minutes] = sessionTime.split(':').map(Number);
    
    const urlParams = new URLSearchParams(window.location.search);
    const simulateTime = urlParams.get('simulate_time');
    
    let now;
    if (simulateTime === 'end') {
      now = new Date('2025-04-26T18:00:00');
    } else {
      now = new Date();
    }
    
    // Vytvoříme datum přednášky ve stejný den jako je now
    const sessionDateTime = new Date(now);
    sessionDateTime.setHours(hours, minutes, 0, 0);
    
    const diffInMinutes = (now - sessionDateTime) / (1000 * 60);
    return diffInMinutes >= 20;
  };

  const SessionCard = ({ session, isCurrent }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSession, setSelectedSession] = useState(null);

    const handleExpand = () => {
      setIsExpanded(!isExpanded);
    };

    const handleOpenModal = (session) => {
      setSelectedSession(session);
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
      setSelectedSession(null);
    };

    return (
      <div className={`session-card ${isCurrent ? 'current' : ''}`}>
        <div className="session-header" onClick={handleExpand}>
          <div className="session-time">{session.time}</div>
          <div className="session-title">{session.title}</div>
          <div className="session-speaker">{session.speaker}</div>
          <div className="session-room">{session.room}</div>
          <div className="expand-icon">{isExpanded ? '▼' : '▶'}</div>
        </div>
        {isExpanded && (
          <div className="session-details">
            <p>{session.description}</p>
            {session.pdfFilename && isSessionOlderThan20Minutes(session.time) && (
              <div className="pdf-download">
                <a 
                  href={`/presentations/${session.pdfFilename}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="pdf-link"
                >
                  📥 Stáhnout prezentaci
                </a>
              </div>
            )}
            <button 
              className="detail-button" 
              onClick={() => handleOpenModal(session)}
            >
              Zobrazit detail
            </button>
          </div>
        )}
        {isModalOpen && selectedSession && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <h2>{selectedSession.title}</h2>
              <p><strong>Čas:</strong> {selectedSession.time}</p>
              <p><strong>Přednášející:</strong> {selectedSession.speaker}</p>
              <p><strong>Místnost:</strong> {selectedSession.room}</p>
              <p><strong>Popis:</strong> {selectedSession.description}</p>
              {selectedSession.pdfFilename && isSessionOlderThan20Minutes(selectedSession.time) && (
                <div className="pdf-download">
                  <a 
                    href={`/presentations/${selectedSession.pdfFilename}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="pdf-link"
                  >
                    📥 Stáhnout prezentaci
                  </a>
                </div>
              )}
              <button className="close-button" onClick={handleCloseModal}>Zavřít</button>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Komponenta informačního panelu
  const InfoPanel = () => (
    <div className="bg-white rounded-xl shadow-sm p-6 sticky top-24 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Informace</h2>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Clock className="w-5 h-5 text-gray-400" />
          <div>
            <p className="text-sm font-medium text-gray-900">Aktuální čas</p>
            <p className="text-2xl font-bold text-gray-900">
              {time.toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' })}
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <MapPin className="w-5 h-5 text-gray-400" />
          <div>
            <p className="text-sm font-medium text-gray-900">Místo konání</p>
            <p className="text-gray-600"><a href="https://mapy.cz/s/maconaloza" target="_blank" rel="noopener noreferrer">Konferenční centrum City</a><br />Na Strži 65, Praha 4</p>
          </div>
        </div>
      </div>
    </div>
  );

  // Získání přednášek s prezentacemi
  const getPresentations = () => {
    return programData
      .filter(item => item.pdfFilename)
      .sort((a, b) => formatTimeForComparison(a.time) - formatTimeForComparison(b.time));
  };

  // Renderování aktuálního pohledu
  const renderView = () => {
    const timeSlots = getTimeSlots();
    
    switch (view) {
      case 'current':
        const { sessions: currentSessions, conferenceStatus } = getCurrentSessions();
        const nextSessions = getNextSessions();
        const now = new Date();
        const conferenceDay1 = new Date('2025-04-25');

        // Zobrazení pro 25. 4. 2025
        if (now.toDateString() === conferenceDay1.toDateString()) {
          return (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Páteční diskusní večer 25. 4.2025 od 18:00</h2>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg space-y-3">
                <p className="text-blue-900 font-medium">
                  Debata od 19:00 - Když Piráti vyrážejí do politiky - debatu se Zdeňkem Hřibem, Ivanem Bartošem, Olgou Richterovou, Bárou Pipášovou a vámi všemi moderuje Mikoláš Tuček.
                </p>
                <p className="text-blue-700">
                  Je to diskusní večer, kde lze osobně probrat všechno, co vás zajímá, jak s bývalým a novým předsedou, tak lídry kandidátek. Předáme si zkušenosti, připravíme se na steč!
                </p>
                <p className="text-gray-700">V čase 18:00 se otevírá paluba a můžeme se neformálně pobavit s kolegy, kamarády a dalšími. Stejně tak po skončení debaty bude prostor ještě na další neformální rozhovory a setkání. Drobné občerstvení a nealko nápoje jsou na nás, alko už jde za vámi a bitcoiny tentokráte nebereme...₿ </p>
              </div>
            </div>
          );
        }

        // Zobrazení před konferencí
        if (conferenceStatus === 'before') {
          return (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Kompas 2025</h2>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                <p className="text-lg font-medium text-blue-900">
                  Konference začne 25. dubna 2025 v 18:00 společným setkáním a debatou a pokračuje v sobotu konferenčním programem 26. dubna 2025 od 9:00 (od 8:00 otevíráme palubu)
                </p>
                <p className="text-blue-700 mt-2">
                  <a href="https://mapy.cz/s/maconaloza" target="_blank" rel="noopener noreferrer">🗺️ Konferenční centrum City</a><br />
                  Na Strži 65, Praha 4
                </p>
                <button 
                  className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md shadow-sm hover:bg-blue-700 transition"
                  onClick={() => setView('timeline')}
                >
                  Zobrazit program podle času
                </button>
              </div>
            </div>
          );
        }
        
        // Zobrazení po konferenci
        if (conferenceStatus === 'after') {
          return (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Kompas 2025</h2>
              <div className="bg-gray-50 border-l-4 border-gray-500 p-4 rounded-lg">
                <p className="text-lg font-medium text-gray-900">
                  Konference skončila 26. dubna 2025. 
                </p>
                <p className="text-gray-700 mt-2">
                Děkujeme všem vystupujícím i účastníkům a příští rok se na vás těšíme zase! V záložce Prezentace si můžete zobrazit prezentace, které byly uvolněny ke stažení a na PiTube budete postupně nacházet i záznamy prezentací z hlavního sálu. 
                </p>
                <button 
                  className="mt-4 bg-gray-600 text-white px-4 py-2 rounded-md shadow-sm hover:bg-gray-700 transition"
                  onClick={() => setView('timeline')}
                >
                  Zobrazit uplynulý program
                </button>
              </div>
            </div>
          );
        }
        
        // Zobrazení pro 26. 4. 2025 (během konference)
        return (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6">Nyní probíhá</h2>
            {currentSessions.length > 0 ? (
              <div className="space-y-4">
                {currentSessions.map((session, index) => (
                  <div key={index} className={`rounded-xl shadow-sm p-4 border-l-4 ${
                    session.room === 'Ekonomika' ? 'bg-gray-50 border-gray-400' :
                    session.room === 'Bydlení & Životní prostředí' ? 'bg-green-50 border-green-400' :
                    session.room === 'Vzdělání & Společnost' ? 'bg-yellow-50 border-yellow-400' :
                    'bg-blue-50 border-blue-400'
                  }`}>
                    <div className="font-bold text-lg mb-2">{session.title}</div>
                    {session.speaker && (
                      <div className="text-gray-600 mb-2">
                        <span className="font-medium">Přednášející:</span> {session.speaker}
                      </div>
                    )}
                    {session.description && (
                      <div className="text-gray-700 mb-2">{session.description}</div>
                    )}
                    <div className={`text-sm font-medium mb-2 ${
                      session.room === 'Ekonomika' ? 'text-gray-800' :
                      session.room === 'Bydlení & Životní prostředí' ? 'text-green-800' :
                      session.room === 'Vzdělání & Společnost' ? 'text-yellow-800' :
                      'text-blue-800'
                    }`}>
                      {session.room}
                    </div>
                    {session.pdfFilename && (
                      <div className="mt-3">
                        <a 
                          href={`/presentations/${session.pdfFilename}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                        >
                          📥 Stáhnout prezentaci
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                <p className="text-gray-500">Žádné přednášky nyní neprobíhají</p>
                <button 
                  className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md shadow-sm hover:bg-blue-700 transition"
                  onClick={() => setView('timeline')}
                >
                  Zobrazit celý program
                </button>
              </div>
            )}

            {nextSessions.length > 0 && (
              <div className="mt-8">
                <h2 className="text-xl font-bold text-gray-900 mb-6">Bude následovat</h2>
                <div className="space-y-4">
                  {nextSessions.map((session, index) => (
                    <div key={index} className={`rounded-xl shadow-sm p-4 border-l-4 ${
                      session.room === 'Ekonomika' ? 'bg-gray-50 border-gray-400' :
                      session.room === 'Bydlení & Životní prostředí' ? 'bg-green-50 border-green-400' :
                      session.room === 'Vzdělání & Společnost' ? 'bg-yellow-50 border-yellow-400' :
                      'bg-blue-50 border-blue-400'
                    }`}>
                      <div className="font-bold text-lg mb-2">{session.title}</div>
                      {session.speaker && (
                        <div className="text-gray-600 mb-2">
                          <span className="font-medium">Přednášející:</span> {session.speaker}
                        </div>
                      )}
                      {session.description && (
                        <div className="text-gray-700 mb-2">{session.description}</div>
                      )}
                      <div className={`text-sm font-medium mb-2 ${
                        session.room === 'Ekonomika' ? 'text-gray-800' :
                        session.room === 'Bydlení & Životní prostředí' ? 'text-green-800' :
                        session.room === 'Vzdělání & Společnost' ? 'text-yellow-800' :
                        'text-blue-800'
                      }`}>
                        {session.room}
                      </div>
                      <div className="text-sm text-gray-500">
                        Začátek v {session.time}
                      </div>
                      {session.pdfFilename && (
                        <div className="mt-3">
                          <a 
                            href={`/presentations/${session.pdfFilename}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                          >
                            📥 Stáhnout prezentaci
                          </a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
        
      case 'timeline':
        return (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6">Sobotní program</h2>
            <div className="space-y-6">
              {timeSlots.map((slot, slotIndex) => (
                <div key={slotIndex}>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4 sticky top-24 bg-white py-2 z-10">
                    {slot}
                  </h3>
                  <div className="space-y-4">
                    {getSessionsByTime(slot).map((session, sessionIndex) => (
                      <div key={sessionIndex} className={`rounded-xl shadow-sm p-4 border-l-4 ${
                        session.room === 'Ekonomika' ? 'bg-gray-50 border-gray-400' :
                        session.room === 'Bydlení & Životní prostředí' ? 'bg-green-50 border-green-400' :
                        session.room === 'Vzdělání & Společnost' ? 'bg-yellow-50 border-yellow-400' :
                        'bg-blue-50 border-blue-400'
                      }`}>
                        <div className="font-bold text-lg mb-2">{session.title}</div>
                        {session.speaker && (
                          <div className="text-gray-600 mb-2">
                            <span className="font-medium">Přednášející:</span> {session.speaker}
                          </div>
                        )}
                        {session.description && (
                          <div className="text-gray-700 mb-2">{session.description}</div>
                        )}
                        <div className={`text-sm font-medium mb-2 ${
                          session.room === 'Ekonomika' ? 'text-gray-800' :
                          session.room === 'Bydlení & Životní prostředí' ? 'text-green-800' :
                          session.room === 'Vzdělání & Společnost' ? 'text-yellow-800' :
                          'text-blue-800'
                        }`}>
                          {session.room}
                        </div>
                        {session.pdfFilename && isSessionOlderThan20Minutes(session.time) && (
                          <div className="mt-3">
                            <a 
                              href={`/presentations/${session.pdfFilename}`} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                            >
                              📥 Stáhnout prezentaci
                            </a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
        
      case 'presentations':
        const presentations = getPresentations();
        return (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6">Prezentace</h2>
            <div className="space-y-4">
              {presentations.map((session, index) => (
                <div key={index} className="bg-white rounded-xl shadow-sm p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm text-gray-500 mb-1">{session.time}</div>
                      <div className="font-medium">{session.speaker} - {session.title}</div>
                    </div>
                    <a 
                      href={`/presentations/${session.pdfFilename}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                    >
                      📥 Stáhnout
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
        
      case 'rooms':
        const rooms = getRooms();
        
        return (
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-6">Program podle sálů</h2>
            <div className="flex flex-wrap gap-2 mb-6 sticky top-24 bg-white py-2 z-10">
              {rooms.map((room, index) => {
                const colors = roomColors[room];
                return (
                  <button
                    key={index}
                    className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                      activeRoom === room
                        ? `${colors.bg} ${colors.text} shadow-md`
                        : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                    onClick={() => setActiveRoom(room)}
                  >
                    <MapPin className="w-4 h-4" />
                    <span>{room}</span>
                  </button>
                );
              })}
              <button
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                  activeRoom === null
                    ? 'bg-blue-100 text-blue-800 shadow-md'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => setActiveRoom(null)}
              >
                <MapPin className="w-4 h-4" />
                <span>Všechny sály</span>
              </button>
            </div>
            
            <div className="space-y-8">
              {timeSlots.map((timeSlot, index) => {
                const sessionsInSlot = getSessionsByTime(timeSlot)
                  .filter(session => !activeRoom || session.room === activeRoom);
                
                if (sessionsInSlot.length === 0) return null;
                
                return (
                  <div key={index} className="bg-white rounded-xl shadow-sm p-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 sticky top-24">
                      {timeSlot}
                    </h3>
                    <div className="overflow-x-auto">
                      <div className={`grid ${
                        activeRoom 
                          ? 'grid-cols-1' 
                          : 'grid-cols-1 md:grid-cols-3'
                        } gap-4 min-w-full`}
                        style={{ 
                          minWidth: activeRoom ? 'auto' : '768px',
                          width: activeRoom ? 'auto' : '100%'
                        }}
                      >
                        {sessionsInSlot.map((session, sessionIndex) => (
                          <div key={sessionIndex} className="h-full">
                            <div className={`h-full p-3 rounded-lg ${
                              session.room === 'Ekonomika' ? 'bg-gray-50 border-l-4 border-gray-400' :
                              session.room === 'Bydlení & Životní prostředí' ? 'bg-green-50 border-l-4 border-green-400' :
                              session.room === 'Vzdělání & Společnost' ? 'bg-yellow-50 border-l-4 border-yellow-400' :
                              'bg-blue-50 border-l-4 border-blue-400'
                            } flex flex-col`}>
                              <div className="font-bold">{session.title}</div>
                              {session.speaker && <div className="text-sm mt-1 text-gray-600">{session.speaker}</div>}
                              {session.description && (
                                <div className="text-sm mt-2 text-gray-700">{session.description}</div>
                              )}
                              <div className={`text-sm mt-auto pt-2 ${
                                session.room === 'Ekonomika' ? 'text-gray-800' :
                                session.room === 'Bydlení & Životní prostředí' ? 'text-green-800' :
                                session.room === 'Vzdělání & Společnost' ? 'text-yellow-800' :
                                'text-blue-800'
                              } font-medium`}>{session.room}</div>
                              {session.pdfFilename && isSessionOlderThan20Minutes(session.time) && (
                                <div className="mt-2">
                                  <a 
                                    href={`/presentations/${session.pdfFilename}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1 text-sm px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                                  >
                                    📥 Stáhnout prezentaci
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
        
      case 'search':
        return (
          <div>
            <h2 className="text-xl font-bold mb-4">Vyhledávání</h2>
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Hledat přednášky, řečníky..."
                className="w-full p-2 pl-10 border rounded-md"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
              {searchTerm && (
                <button
                  className="absolute right-3 top-2.5 text-gray-500"
                  onClick={() => handleSearch('')}
                >
                  ×
                </button>
              )}
            </div>
            
            {searchTerm ? (
              searchResults.length > 0 ? (
                <div>
                  <div className="text-sm text-gray-500 mb-3">
                    Nalezeno {searchResults.length} výsledků
                  </div>
                  {searchResults.map((session, index) => (
                    <SessionCard key={index} session={session} isCurrent={false} />
                  ))}
                </div>
              ) : (
                <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                  <p className="text-gray-500">Žádné výsledky nenalezeny</p>
                </div>
              )
            ) : (
              <div className="bg-white rounded-xl shadow-sm p-6 text-center">
                <p className="text-gray-500">Zadejte hledaný výraz</p>
              </div>
            )}
          </div>
        );
        
      default:
        return null;
    }
  };

  // Mobilní navigace ve spodní části obrazovky
  const MobileNavigation = () => (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t z-20">
      <div className="flex justify-around">
        <button 
          className={`py-3 px-4 flex flex-col items-center ${view === 'current' ? 'text-blue-600' : 'text-gray-600'}`}
          onClick={() => setView('current')}
        >
          <Clock className="w-6 h-6" />
          <span className="text-xs mt-1">Nyní</span>
        </button>
        
        <button 
          className={`py-3 px-4 flex flex-col items-center ${view === 'presentations' ? 'text-blue-600' : 'text-gray-600'}`}
          onClick={() => setView('presentations')}
        >
          <FileText className="w-6 h-6" />
          <span className="text-xs mt-1">Prezentace</span>
        </button>
        
        <button 
          className={`py-3 px-4 flex flex-col items-center ${view === 'rooms' ? 'text-blue-600' : 'text-gray-600'}`}
          onClick={() => setView('rooms')}
        >
          <MapPin className="w-6 h-6" />
          <span className="text-xs mt-1">Sály</span>
        </button>
        
        <button 
          className={`py-3 px-4 flex flex-col items-center ${view === 'search' ? 'text-blue-600' : 'text-gray-600'}`}
          onClick={() => setView('search')}
        >
          <Search className="w-6 h-6" />
          <span className="text-xs mt-1">Hledat</span>
        </button>
      </div>
    </nav>
  );

  const styles = `
    body {
      margin: 0;
      padding: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      background-color: #f5f5f5;
    }

    .app-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px;
    }

    .header {
      text-align: center;
      margin-bottom: 30px;
    }

    .header h1 {
      color: #333;
      font-size: 2.5rem;
      margin-bottom: 10px;
    }

    .header p {
      color: #666;
      font-size: 1.1rem;
    }

    .search-container {
      margin-bottom: 30px;
    }

    .search-input {
      width: 100%;
      padding: 12px 20px;
      font-size: 16px;
      border: 2px solid #ddd;
      border-radius: 8px;
      outline: none;
      transition: border-color 0.3s;
    }

    .search-input:focus {
      border-color: #4a90e2;
    }

    .tabs {
      display: flex;
      gap: 10px;
      margin-bottom: 20px;
    }

    .tab {
      padding: 10px 20px;
      background: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;
    }

    .tab.active {
      background: #4a90e2;
      color: white;
    }

    .session-card {
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      margin-bottom: 15px;
      overflow: hidden;
    }

    .session-card.current {
      border-left: 4px solid #4a90e2;
    }

    .session-header {
      padding: 15px;
      display: flex;
      align-items: center;
      gap: 15px;
      cursor: pointer;
      transition: background-color 0.3s;
    }

    .session-header:hover {
      background-color: #f8f9fa;
    }

    .session-time {
      font-weight: bold;
      min-width: 60px;
    }

    .session-title {
      flex: 1;
      font-weight: 500;
    }

    .session-speaker {
      color: #666;
    }

    .session-room {
      color: #4a90e2;
      font-weight: 500;
    }

    .expand-icon {
      color: #666;
    }

    .session-details {
      padding: 15px;
      background-color: #f8f9fa;
      border-top: 1px solid #eee;
    }

    .pdf-download {
      margin: 15px 0;
    }

    .pdf-link {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      background-color: #4a90e2;
      color: white;
      text-decoration: none;
      border-radius: 4px;
      transition: background-color 0.3s;
    }

    .pdf-link:hover {
      background-color: #357abd;
    }

    .detail-button {
      padding: 8px 16px;
      background-color: #f8f9fa;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
    }

    .detail-button:hover {
      background-color: #e9ecef;
    }

    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }

    .modal-content {
      background: white;
      padding: 30px;
      border-radius: 8px;
      max-width: 600px;
      width: 90%;
      max-height: 90vh;
      overflow-y: auto;
    }

    .modal-content h2 {
      margin-top: 0;
      color: #333;
    }

    .modal-content p {
      margin: 10px 0;
      color: #666;
    }

    .close-button {
      margin-top: 20px;
      padding: 10px 20px;
      background-color: #4a90e2;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.3s;
    }

    .close-button:hover {
      background-color: #357abd;
    }

    .time-slot {
      margin-bottom: 30px;
    }

    .time-slot h3 {
      color: #333;
      margin-bottom: 15px;
      padding-bottom: 5px;
      border-bottom: 2px solid #eee;
    }

    .current-time {
      background-color: #e3f2fd;
      padding: 10px;
      border-radius: 8px;
      margin-bottom: 20px;
      text-align: center;
    }

    .current-time h2 {
      margin: 0;
      color: #4a90e2;
    }

    .no-sessions {
      text-align: center;
      color: #666;
      padding: 20px;
    }
  `;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pb-16 md:pb-0">
      {/* Hlavička */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Kompas 2025</h1>
              <p className="text-sm text-gray-500 mt-1">25.-26. dubna 2025, Praha</p>
            </div>
            
            {/* Vyhledávání */}
            <div className="w-full sm:w-64 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Hledat v programu..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Desktopová navigace */}
          {!isMobile && (
            <nav className="mt-4 flex flex-wrap gap-2">
              <button
                onClick={() => setView('current')}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                  view === 'current' 
                    ? 'bg-blue-500 text-white shadow-md' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Clock className="w-5 h-5" />
                <span>Nyní probíhá</span>
              </button>
              
              <button
                onClick={() => setView('presentations')}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                  view === 'presentations' 
                    ? 'bg-blue-500 text-white shadow-md' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <FileText className="w-5 h-5" />
                <span>Prezentace</span>
              </button>
              
              <button
                onClick={() => setView('rooms')}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                  view === 'rooms' 
                    ? 'bg-blue-500 text-white shadow-md' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <MapPin className="w-5 h-5" />
                <span>Podle sálů</span>
              </button>
              
              <button
                onClick={() => setView('search')}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 ${
                  view === 'search' 
                    ? 'bg-blue-500 text-white shadow-md' 
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Search className="w-5 h-5" />
                <span>Vyhledávání</span>
              </button>

            </nav>
          )}
        </div>
      </header>

      {/* Hlavní obsah */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Levý panel s informacemi (pouze na desktopu) */}
          {!isMobile && (
            <div className="lg:col-span-1">
              <InfoPanel />
            </div>
          )}

          {/* Hlavní obsah */}
          <div className={isMobile ? "col-span-1" : "lg:col-span-3"}>
            {renderView()}
          </div>
        </div>
      </main>
      
      {/* Mobilní navigace */}
      {isMobile && <MobileNavigation />}
    </div>
  );
};

export default KompasApp;
